module.exports = __webpack_public_path__ + "static/img/12areaB_05.d9f25c9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/12areaB_05.png
// module id = 1097
// module chunks = 1